
import { mixins } from 'vue-class-component'
import { Component } from 'vue-property-decorator'
import mixin from './mixin'
import itemMixin from './item-mixin'

@Component
export default class SideMenuItem extends mixins(mixin, itemMixin) {
    name = 'SideMenuItem'
}
